const isProduction = import.meta.env.MODE === 'production';

/**
 * PII protection: replaces any string value containing '@' with '[REDACTED]'.
 * Recursively scans objects and arrays.
 */
const sanitize = (val: any): any => {
  if (typeof val === 'string' && val.includes('@')) {
    return '[REDACTED]';
  }
  if (val !== null && typeof val === 'object') {
    if (Array.isArray(val)) {
      return val.map(sanitize);
    }
    const sanitized: Record<string, any> = {};
    for (const [key, value] of Object.entries(val)) {
      sanitized[key] = sanitize(value);
    }
    return sanitized;
  }
  return val;
};

export const logger = {
  debug: (message: string, meta?: Record<string, unknown>) => {
    if (isProduction) return;
    const sanitizedMsg = sanitize(message);
    const sanitizedMeta = sanitize(meta);
    console.log(`[DEBUG] ${sanitizedMsg}`, sanitizedMeta || '');
  },

  info: (message: string, meta?: Record<string, unknown>) => {
    if (isProduction) return;
    const sanitizedMsg = sanitize(message);
    const sanitizedMeta = sanitize(meta);
    console.log(`[INFO] ${sanitizedMsg}`, sanitizedMeta || '');
  },

  warn: (message: string, meta?: Record<string, unknown>) => {
    if (isProduction) return;
    const sanitizedMsg = sanitize(message);
    const sanitizedMeta = sanitize(meta);
    console.warn(`[WARN] ${sanitizedMsg}`, sanitizedMeta || '');
  },

  error: (message: string, meta?: Record<string, unknown>) => {
    const sanitizedMsg = sanitize(message);
    const sanitizedMeta = sanitize(meta);

    if (isProduction) {
      const sentryCapture = (window as any).__SENTRY_EARLY_CAPTURE__;
      if (typeof sentryCapture === 'function') {
        sentryCapture(new Error(sanitizedMsg), { extra: sanitizedMeta });
      }
      return;
    }

    console.error(`[ERROR] ${sanitizedMsg}`, sanitizedMeta || '');
  }
};
